import { render, staticRenderFns } from "./CommentForm.vue?vue&type=template&id=0ac41921&scoped=true"
import script from "./CommentForm.vue?vue&type=script&lang=js"
export * from "./CommentForm.vue?vue&type=script&lang=js"
import style0 from "./CommentForm.vue?vue&type=style&index=0&id=0ac41921&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ac41921",
  null
  
)

export default component.exports